import { BaseModel } from "models/BaseModel";
import { PlateConsultResponse } from "services/plateTagService";

export class PlateConsult extends BaseModel<PlateConsultResponse> {
	tag: string;
	empresa: string;
	situacao: string;

	constructor(data: PlateConsultResponse) {
		super(data);
		this.tag = data.tag;
		this.empresa = data.empresa;
		this.situacao = data.situacao;
	}

	static createFromResponse(response: PlateConsultResponse) {
		return new this(response);
	}
}
